<template>
    <div id="detail">
        <detail-nav-bar ref="dertainavbar" @titleClick="titleClick"></detail-nav-bar>
        <Scroll class="wrapper" ref="scroll"
                :probe-type="3"
                @scroll="contentScroll"
                :pull-up-load="true"
                @pullingUp="loadRefresh">
            <detail-swiper :top-images="topImages"></detail-swiper>
            <detail-base-info :goods="Goods"></detail-base-info>
            <detail-shop-info :shop="Shop"></detail-shop-info>
            <detail-image-info  :detail-info="detaliInfo" @detailImageLoad="detailImageLoad"></detail-image-info>
            <detail-param-info ref="params" :param-info="paramInfo"></detail-param-info>
            <detail-comment-info ref="comment" :comment-info="commentInfo"></detail-comment-info>
            <detail-recommend-info ref="recommend" :recommend-list="recommendList"></detail-recommend-info>
            <!--                <detail-bottom-bar></detail-bottom-bar>-->
        </Scroll>
        <detail-bottom-bar @addToCart="addToCart"></detail-bottom-bar>
        <!--        <toast :message="message" :show="show"></toast>-->
    </div>
</template>

<script>
    import DetailNavBar from "./childComps/DetailNavBar";
    import Scroll from "../../components/common/scroll/Scroll";

    import DetailSwiper from "./childComps/DetailSwiper";
    import DetailBaseInfo from "./childComps/DetailBaseInfo";
    import DetailShopInfo from "./childComps/DetailShopInfo";

    import DetailImageInfo from "./childComps/DetailImageInfo";
    import DetailParamInfo from "./childComps/DetailParamInfo";
    import DetailCommentInfo from "./childComps/DetailCommentInfo";
    import DetailRecommendInfo from "./childComps/DetailRecommendInfo";
    import DetailBottomBar from "./childComps/DetailBottomBar";

    import {getDetail,Goods,Shop,GoodsParam, getRecommend} from "../../components/network/detail";
    import {goodsitemImageLoadRefresh} from "../../components/common/mixin";
    import {debounce} from "../../components/common/utils";
    import Toast from "../../components/common/toast/Toast";


    export default {
        name: "MallDetail",
        components:{
            DetailNavBar,
            Scroll,

            DetailSwiper,
            DetailBaseInfo,
            DetailShopInfo,
            DetailImageInfo,
            DetailParamInfo,
            DetailCommentInfo,
            DetailRecommendInfo,
            DetailBottomBar,
            // Toast
        },
        mixins:[goodsitemImageLoadRefresh],
        data(){
            return{
                iid:null,
                topImages:[],
                detaliInfo:{},
                Goods:{},
                Shop:{},
                paramInfo:{},
                commentInfo:{},
                recommendList:[],
                themeTopYs:[],
                getThemeTopy:null,
                message:'加入购物车',
                show:false,

            }
        },
        created() {
            this.iid=this.$route.params.iid;
            getDetail(this.iid).then(res=>{
                const data=res.result;
                this.topImages=data.itemInfo.topImages;
                // console.log(res);
                this.Goods=new Goods(data.itemInfo,data.columns,data.shopInfo.services)
                this.Shop=new Shop(data.shopInfo);
                this.detaliInfo=data.detailInfo;
                this.paramInfo=new GoodsParam(data.itemParams.info,data.itemParams.rule);
                if(data.rate.list){
                    this.commentInfo=data.rate.list[0];
                }

            });
            getRecommend().then((res,error)=>{
                if(error) return;
                this.recommendList=res.data.list;
            });
            this.getThemeTopy =debounce(()=>{
                this.themeTopYs=[];
                this.themeTopYs.push(0);
                this.themeTopYs.push(this.$refs.params.$el.offsetTop);
                this.themeTopYs.push(this.$refs.comment.$el.offsetTop);
                this.themeTopYs.push(this.$refs.recommend.$el.offsetTop);
                // console.log(this.themeTopYs);
            },100)
            // this.newRefresh=this.debounce(this.$refs.scroll.refresh(),100);

        },
        mounted() {


        },
        destroyed() {
            //取消对全局事件对该组件this.GoodsListItemImgListener的监听
            this.$bus.$off(this.GoodsListItemImgListener);
        },
        methods:{
            addToCart(){
                const product={};
                product.image=this.topImages[0];
                product.title=this.Goods.title;
                product.desc=this.Goods.desc;
                product.price=this.Goods.realPrice;
                product.iid=this.iid;
                this.$store.dispatch('addCart',product);
                this.$toast.show('添加成功，在购物车等亲~',1000);


            },
            detailImageLoad(){
                this.newRefresh();
                this.getThemeTopy();
            },
            loadRefresh(){
                // this.$refs.scroll.refresh();
                // this.newRefresh();
            },
            titleClick(index){
                // console.log(index);
                this.$refs.scroll.scrollTo(0,-this.themeTopYs[index],0);
                // console.log(this.themeTopYs);
            },
            contentScroll(position){
                let currentIndex=this.$refs.dertainavbar.currentIndex;
                // let length=this.themeTopYs.length;
                // switch(currentIndex){
                //     case 0:
                //         if(position.y<-this.themeTopYs[1]){
                //             this.$refs.dertainavbar.currentIndex=1;
                //         }
                //         break;
                //     case length-1:
                //         if(position.y>-this.themeTopYs[length-1]){
                //             this.$refs.dertainavbar.currentIndex=length-2;
                //         }
                //         break;
                //     default:
                if(position.y>-this.themeTopYs[currentIndex]){
                    this.$refs.dertainavbar.currentIndex=currentIndex-1;
                }
                else if(position.y<-this.themeTopYs[currentIndex+1])
                {
                    this.$refs.dertainavbar.currentIndex=currentIndex+1;
                }
                // }
            }
        }
    }
</script>

<style scoped>
    #detail{
        height: 100vh;
        position: relative;
        z-index: 9;
        background-color: #fff;

    }

    .wrapper{
        position: relative;
        /*top: 44px;*/
        height: calc(100% - 93px);
        /*height: 550px;*/
        /*background-color: red;*/
        overflow: hidden;
    }
</style>